import { render, staticRenderFns } from "./RelatedArticlesSelect.vue?vue&type=template&id=8204c4b8"
import script from "./RelatedArticlesSelect.vue?vue&type=script&lang=js"
export * from "./RelatedArticlesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports